// @ts-nocheck
import * as React from "react";

const Download: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M19 16a1 1 0 011 1v2a1 1 0 01-.883.993L19 20H5a1 1 0 01-1-1v-2a1 1 0 01.883-.993L5 16a1 1 0 011 1v.999h12V17a1 1 0 01.883-.993L19 16zm-6.001-3.993L15.4 10.2a1 1 0 111.2 1.6l-4 3a1 1 0 01-.471.192L12 15a1 1 0 01-.58-.18l-4-2.82a1 1 0 01-.305-1.283l.065-.107a1 1 0 011.4-.24l2.423 1.692L11 12V4a1 1 0 011.993-.117L13 4l-.001 8.007z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Download);
